import React ,{Component} from "react";
import {Loading} from "./partials/Global/Loading";
import {Col, Container, Row} from "react-bootstrap";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";


class AboutUs extends Component {
    render() {
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="page-header section-padding pt-0">
                        <Container className="mt-80">
                            <Row >
                                <Col lg={8}>
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>معرفی شرکت</span>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>درباره ما</span>
                                        </div>
                                        <h2 className="fz-25">درباره‌ی ما</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p>
                                            شرکت سرمایه‌گذاری عمران و توسعه پایدار ایرانیان (سهامی خاص) در راستای سیاست‌ها و اهداف بانک اقتصادنوین در تاریخ ۱۳۸۷/۰۳/۰۶ به‌عنوان یک شرکت ساختمانی به ثبت رسیده‌است و از اواسط سال ۱۳۸۹ فعالیت جدی خود را با به‌کارگیری منابع انسانی متخصص، با‌دانش و خلاق و بهره‌گیری از فن‌آوری‌های نوین و ارتقای کیفیت و تکیه بر ارزش‌های متعالی، در جهت سودآوری و رضایت ذی‌نفعان در شرایط رقابتی و خلق ارزش در صنعت ساختمان و املاک و مستغلات کشور آغاز نموده‌است.
                                        </p>
                                        <br/>
                                        <p>
                                            خلاصه فعالیت‌های شرکت در حال حاضر به شرح زیر می‌باشد:
                                        </p>
                                        <p className=''><ul>
                                            <li>- مدیریت، طراحی و ساخت پروژه‌های ساختمانی</li>
                                            <li>- اقدامات لازم جهت تملیک (انجام امور ثبتی، اجرایی، شهرداری، دارایی و غیره)، اخذ اسناد مالکیت و تعیین تکلیف املاک شش دانگ و مشاعی (خلع ید، اجرت‌المثل و غیره)</li>
                                            <li>- ارزش‌گذاری املاک، برگزاری مزایده، بازاریابی و فروش، نگهداری و بازسازی و بهسازی اموال و املاک تملیکی</li>
                                            <li>- مطالعه، طراحی، جابجایی، تعمیر، بازسازی، تجهیز و راه‌اندازی شعب بانک</li>
                                            <li>- ارائه گزارش‌های تحلیلی به منظور تصمیم‌سازی صحیح در زمینه املاک و مستغلات در حال تملیک</li>
                                            <li>- ارائه خدمات مطالعاتی و تحقیقاتی (مکان‌یابی، امکان‌سنجی، توجیه فنی و اقتصادی و ...) در حوزه ساختمان و املاک و مستغلات</li>
                                            <li>- مدیریت بهره‌برداری از املاک و دارایی‌ها</li>
                                            <li>- ایجاد پایگاه اطلاعاتی و راه‌اندازی سامانه مدیریت املاک </li>
                                        </ul></p>
                                    </div>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">پیام مدیرعامل</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="justify-content-center mb-20">
                                <Col lg={6} className="text-center">
                                    <div className="text">
                                        <h6>بسم الله الرحمن الرحیم</h6>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="justify-content-center mb-10">
                                <Col lg={2}> </Col>
                                <Col lg={4} className="text-center">
                                    <div className="text">
                                        <h6 className="fz-16">به جهان خرم از آنم که جهان خرم از اوست</h6>
                                    </div>
                                </Col>
                                <Col lg={4} className="text-center">
                                    <div className="text">
                                        <h6 className="fz-16">عاشقم بر همه عالم که همه عالم از اوست</h6>
                                    </div>
                                </Col>
                                <Col lg={2}> </Col>
                            </Row>
                            <Row className="justify-content-center mb-40">
                                <Col lg={6}> </Col>
                                <Col lg={6} className="text-center">
                                    <div className="text">
                                        <span className="sub-title">«استاد سخن، سعدی»</span>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="justify-content-center mb-40">
                                <Col lg={10}>
                                    <div className="text text-justify">
                                        <p>
                                            در سایه‌‌ی عنایت حضرت حق، تیم توانمند و متخصص عمران و توسعه پایدار ایرانیان گام‌‌های بلندی برای پیشرفت و تعالی برداشته است؛ آری ما یک تیم هستیم که برای انجام وظایف به جهان، به طبیعت و به هم‌نوع عشق می‌‌ورزیم و احترام می‌‌گذاریم. برای ما کار بهانه‌‌ای ‌است برای دوست داشتن و دوست داشته شدن، برای پیمودن راه کمال انسانی و ارزش‌‌های اخلاقی.
                                        </p>
                                        <p>
                                            تیم توانمند و متخصص ما، خلق ارزش می‌‌کند و سعی می‌‌کند فضا را به بهترین شکل آن معنا کند و از نو شروع کردن و از نو آموختن را تجربه کند و خود را به چالش می‌‌کشد تا روزگار به حکم سنگ‌تراش، اثری مانا بر جانمان بتراشد که بتوانیم پاسدار تنها مایملک جاودان بشری، که همانا ارزش‌‌های  اخلاقی است، باشیم.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg={6} className="text-center">
                                    <div className="text">
                                        <h6 className='fz-16'>'خداوند ما و شما را یاری کند'</h6>
                                        <h6 className='fz-16'>'با هم تا قله‌‌های افتخار'</h6>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="justify-content-center mb-40">
                                <Col lg={10}>
                                    <div className="text" style={{position: 'absolute', left: '10%'}}>
                                        <span>صابر دهقانی</span>
                                    </div>
                                </Col>
                            </Row>
                            <Row >
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">منشور اخلاقی</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p>
                                            ما کارکنان شرکت در راستای اهداف محوری سازمان و حفظ و ایجاد مزیت‌‌های رقابتی پایدار، با تاسی از تعالیم و احکام الهی، اصول صداقت، امانت‌داری، حفظ حرمت و منزلت انسانی، پای‌بندی به اخلاق حرفه‌ای تکریم ارباب رجوع، تلاش در جلب رضایت ذی‏نفعان را پاس داشته و در تحقق این اصول مشارکتی فعالیت خواهیم داشت. ما به ارزش‌‌های اخلاقی و حرفه‌ای دوازده‌گانه زیر پای‌بند بوده و با رعایت مفاد منشور اخلاقی (اصول رفتار حرفه‌ای مدیران و مسئولین در 121 بند و اصول رفتار حرفه‌ای کارکنان در 46 بند) آن‌‌ها را از عمق وجود باور داشته و سرلوحه‌‌ی کار خود قرار می‌‌دهیم.
                                        </p>
                                        <br/>
                                        <p><ul>
                                            <li>- توکل به خدای منان، مددجوئی از او و تلاش در پای‌بندی به اصول اخلاقی و رعایت عدالت و انصاف</li>
                                            <li>- تلاش در ارزش‌آفرینی مستمر برای مشتریان، سهام ‌داران، شرکت و همکاران</li>
                                            <li>- داشتن وجدان‌ کاری، پشتکار، جدیت و مسئولیت‌پذیری در حسن انجام وظیفه</li>
                                            <li>- رعایت کامل ادب، احترام به اعتقادات و فرهنگ انسانی و همکاران و وفاداری نسبت به شرکت</li>
                                            <li>- پاسخ‌گویی کامل و درست به انتظارات و گره‌گشایی مشکلات اشخاص حقیقی و حقوقی ذیربط</li>
                                            <li>- فراهم‌ سازی به ‌موقع اطلاعات شفاف و جامع برای ذینفعان و مراجع نظارتی</li>
                                            <li>- حفظ، به‌روز‌رسانی و مدیریت دانش و تجربه‌ی سازمانی و به اشتراک گذاشتن آن</li>
                                            <li>- مبارزه با سوء استفاده و فساد، جرائم سازمان یافته و تخلفات احتمالی</li>
                                            <li>- افزایش سطح مشارکت جمعی، کوشش و اهتمام، خلاقیت، دقت، کیفیت، سرعت و امانت ‌داری در انجام خدمات</li>
                                            <li>- استفاده از تمام ظرفیت فکری و عملیاتی خود در حسن انجام مسئولیت‌های حرفه‌ای و سازمانی و اجتماعی</li>
                                            <li>- رعایت قوانین و مقررات، نظم و انضباط اداری و حقوق سازمان و همکاران در همه‌ی شرایط</li>
                                            <li>- استفاده موثر از نظرات، پیشنهادات و انتقادات بعنوان یکی از فرصت‌های استراتژیک</li>
                                        </ul></p>
                                    </div>
                                </Col>
                            </Row>
                            <Row >
                                <Col lg={8} className='mb-40 mt-40'>
                                    <div className="caption">
                                        <h2 className="fz-25">فیلم معرفی شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={10} className='m-auto'>
                                    <video width="100%" controls>
                                        <source src={process.env.REACT_APP_BASE_URL + "/images/video.mp4"}  type="video/mp4"/>
                                        Your browser does not support HTML video.
                                    </video>
                                </Col>
                            </Row>
                        </Container>
                    </header>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default AboutUs;
